import type ErrorStatus from '$shared/constants/ErrorStatus';
import type IServiceError from '$shared/interfaces/IServiceError';
import type { AlertDetailedInfo } from './AlertDetailedInfo';
import type { ErrorMessage } from './ErrorMessage';

export default class ServiceError extends Error implements IServiceError {
  readonly status: ErrorStatus;
  readonly title: string;
  readonly message: string;
  readonly errors?: Record<string, string[]>;
  // For UI purpose
  public errorAlert?: AlertDetailedInfo;

  constructor(
    status: ErrorStatus,
    title: string,
    message: string,
    errors?: Record<string, string[]>
  ) {
    super(message);
    this.status = status;
    this.title = title;
    this.message = message;
    this.errors = errors;
  }

  public setDetailErrorAlert(errorAlert: AlertDetailedInfo): void {
    this.errorAlert = errorAlert;
  }

  static create(
    status: ErrorStatus,
    errorMessage: ErrorMessage,
    errors?: Record<string, string[]>
  ): ServiceError {
    return new ServiceError(status, errorMessage?.title, errorMessage?.message, errors);
  }
}
